import { Pipe, PipeTransform } from '@angular/core';
import { LowerCasePipe } from '@angular/common';

@Pipe({
  name: 'titleCase'
})
export class TitleCasePipe implements PipeTransform {

  transform(value: string): any {
    if (value) {

      const lowerCasePipe = new LowerCasePipe();
      const string = lowerCasePipe.transform(value);
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
      return '';
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/pipes/title-case.pipe.ts